import { render, staticRenderFns } from "./updateWork.vue?vue&type=template&id=76bb63a2&scoped=true&"
import script from "./updateWork.vue?vue&type=script&lang=js&"
export * from "./updateWork.vue?vue&type=script&lang=js&"
import style0 from "./updateWork.vue?vue&type=style&index=0&id=76bb63a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb63a2",
  null
  
)

export default component.exports